import queryString from 'query-string';

export function buildQuery(name, appliedFilters) {
    let query = '';

    if (appliedFilters && appliedFilters.length) {
        appliedFilters.map((filter, index) => filter.tab === 'common' ? {...filter, index: index} : filter).forEach(function(item) {
            if (item.value && item.value.length > 0 && (item.tab === name || item.tab === 'common') && !(item.tab === 'common' && item.index > 0)) {
                query += '&';
                query += queryString.stringify({
                    [item.id]: item.value.map(option => option.id)
                }, {arrayFormat: 'index'});
            }
        });
    }
    return query;
};

export function buildQueryHeadingsDetails(name, appliedFilters, headingFilters, headingFiltersSelected, headingId) {
    let query = '';
    
    if (appliedFilters && appliedFilters.length) {
      appliedFilters.map((filter, index) => filter.id === 'HEADINGS' ? {...filter, index: index} : filter).forEach(function(item) {
        if (item.value && item.value.length > 0 && ((item.tab === name || item.tab === 'common' || item.id === 'HEADINGS') && !(item.id === 'HEADINGS' && item.index > 0))) {
          query += '&';
          query += queryString.stringify({
            [item.id]: item.value.map(option => option.id)
          }, {arrayFormat: 'index'});
        }
      });
    }

    if ((!appliedFilters || !appliedFilters.length) && headingId) {
        query += '&';
        query += queryString.stringify({
          'HEADINGS': [headingId]
        }, {arrayFormat: 'index'});
    }

   if (headingFiltersSelected) {
        headingFiltersSelected.forEach(function(item) {
            //FAKE SELECTED
            query += '&';
            query += queryString.stringify({
              [item.id]: [item.value]
            }, {arrayFormat: 'index'});
        });
    } else {
        headingFilters.forEach(function(item) {
            //FAKE SELECTED
            if (item.type === 'SELECT' && item.options) {
                const currentOptions = item.options.filter(option => option.selected);

                currentOptions.forEach(function(currentOption){
                  query += '&';
                  query += queryString.stringify({
                    [item.name]: [currentOption.id]
                  }, {arrayFormat: 'index'});
                });
            }
        });
    }

    // if (selectedOption) {
    //     headingFilters.forEach(function(item) {
    //         //FAKE SELECTED
    //         if (item.type !== 'SELECT' && item.selected) {
    //             query += '&';
    //             query += queryString.stringify({
    //               [item.name]: [selectedOption.code]
    //             }, {arrayFormat: 'index'});
    //         }
    //     });
    // }


    const headingFiltersSelect = headingFilters ? headingFilters.filter(filter => filter.type === "SELECT") : false;
    const selectedOption = headingFiltersSelect ? headingFiltersSelect.filter(option => option.options.filter(item => item.selected && item.id !== "0").length > 0) : false;
    const selectedOptionFiltered = selectedOption ? selectedOption[selectedOption.length - 1] : false;
    const selectedOptionFilteredOptions = selectedOptionFiltered ? selectedOptionFiltered.options.filter(option => option.selected) : false;
    const itemSelected = headingFilters.filter(item => item.selected)[0];
   
    if (itemSelected) {
      query += '&';
      query += queryString.stringify({
        [itemSelected.name]: selectedOptionFilteredOptions && selectedOptionFilteredOptions[0] ? [selectedOptionFilteredOptions[0].code] : [itemSelected.options[0].id]
      }, {arrayFormat: 'index'});
    } else {
      headingFilters.forEach(function(item) {
          //FAKE SELECTED
          const optionSelected = item.options.filter(option => option.selected)[0];
          if (item.type !== 'SELECT') {
              query += '&';
              query += queryString.stringify({
                [item.name]: optionSelected ? [optionSelected.id] : [item.options[0].id]
              }, {arrayFormat: 'index'});
          }
      });
    }

    return query;
};



// WEBPACK FOOTER //
// ./src/scripts/ResultsFiltersQueryBuild.js